import * as React from 'react';
import { ConnectedListContainer } from '../../common/components/list-container';
import { ConnectedFilterTextbox } from '../../common/components/filter-textbox';
import { ConnectedFiltersHeader } from '../../common/components/filters-header';
import { ConnectedFilterRadio } from '../../common/components/filter-radio';
import { ConnectedClearAll } from '../../common/components/clear-all';
import ConnectedDashBoard from '../../common/components/result-dashboard';
import { ConnectedScrollToTop } from '../../common/components/scroll-to-top';
import { IAppState } from '../../common/classes/app';
import { connect } from 'react-redux';
import { EventListItem } from './list-item';
import { ConnectedCalendarFilter } from './calendar-filter';
import { ConnectedFilterChecklist } from '../../common/components/filter-checklist';
export interface AppExternalProps {
    searchBoxDefault?: string
}

interface StateToProps {
    isMobile: boolean;
}

type ProviderAppProps = StateToProps & AppExternalProps;

export const EventAppBase: React.StatelessComponent<ProviderAppProps> = props => {
    return (
        <div>
            <div className="adage-search-input">
                <div className="adage-search-input-inner">
                    <h1>Find an Event</h1>
                    <ConnectedFilterTextbox clickToSubmit={true} property="QueryValue" title="" defaultTextBoxValue={props.searchBoxDefault} showMoreLink={false} />
                </div>
            </div>
            <div className="adage-search">
                <div className="adage-search-rail">
                    <div className="adage-search-filters adage-search-rail-inner adage-search-rail-inner-js">
                        <ConnectedFiltersHeader />

                        <div id="searchFilters" className="adage-search-filters-content" aria-hidden={props.isMobile ? "true" : null}>
                            <div className="adage-search-reset">
                                <ConnectedClearAll text="Clear All" />
                            </div>

                            <div className="adage-search-filters-facets">
                                <div className="adage-search-filters-facets-column">
                                    <div className="adage-search-facet-group">
                                        <h3 className="adage-search-facet-group-title">Date</h3>
                                        <ConnectedCalendarFilter />
                                    </div>
                                </div>

                                <div className="adage-search-filters-facets-column">
                                    <div className="adage-search-facet-group">
                                        <h3 className="adage-search-facet-group-title">Location</h3>
                                        <ConnectedFilterTextbox clickToSubmit={false} property="ziporcity" title="Zip or City" showMoreLink={false} />
                                    </div>

                                    <div className="adage-search-facet-group">
                                        <h3 className="adage-search-facet-group-title">Event Type</h3>
                                        <ConnectedFilterChecklist property="eventtype" title="Event Type" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="adage-search-main">
                    <ConnectedListContainer itemType="Events" providerFilters="" listItemComponent={props => <EventListItem key={props.id+props.date} {...props} />} />
                </div>

                <ConnectedScrollToTop />
            </div>
        </div>
    )
}


function mapStateToProps(state: IAppState): StateToProps {
    return {
        isMobile: state.responsiveState.isMobile
    }
}

export const EventApp = connect(mapStateToProps)(EventAppBase);